import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "sub-layer-checkbox__content" }
const _hoisted_2 = { class: "sub-layer-checkbox__row" }
const _hoisted_3 = ["id", "checked"]
const _hoisted_4 = {
  key: 0,
  class: "sub-layer-checkbox__icon-wrapper"
}
const _hoisted_5 = {
  key: 1,
  class: "sub-layer-checkbox__icon-wrapper"
}
const _hoisted_6 = ["for"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translated_text_component = _resolveComponent("translated-text-component")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
    'sub-layer-checkbox': true,
    'sub-layer-checkbox--checked': _ctx.checked,
  })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass({
          'sub-layer-checkbox__input': true,
          'sub-layer-checkbox__input--checked': _ctx.checked
        })
        }, [
          _createElementVNode("input", {
            id: `sub-${_ctx.label}`,
            type: "checkbox",
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change', $event))),
            checked: _ctx.checked,
            value: "checked"
          }, null, 40, _hoisted_3)
        ], 2),
        (_ctx.isDynamic)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.icon)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["sub-layer-checkbox__icon", {'sub-layer-checkbox__icon--active': _ctx.checked}]),
                    style: _normalizeStyle(`mask: url(data:image/svg+xml;base64,${_ctx.icon}) no-repeat center; mask-size: contain;`)
                  }, null, 6))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass(["sub-layer-checkbox__icon", {'sub-layer-checkbox__icon--active': _ctx.checked}]),
                style: _normalizeStyle(`mask: url(${_ctx.getIconUrl(_ctx.icon)}) no-repeat center;`)
              }, null, 6)
            ]))
      ])
    ]),
    _createElementVNode("label", {
      for: `sub-${_ctx.label}`,
      class: _normalizeClass(["sub-layer-checkbox__title", {'sub-layer-checkbox__title--active': _ctx.checked}])
    }, [
      (_ctx.isDynamic)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
            (_ctx.hasTranslation)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _createVNode(_component_translated_text_component, { translation: _ctx.label }, null, 8, ["translation"])
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.label), 1))
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_10, [
            _createVNode(_component_translated_text_component, { translation: _ctx.label }, null, 8, ["translation"])
          ]))
    ], 10, _hoisted_6)
  ], 2))
}